import React from 'react'

const Raravraman = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका पदावली र अर्थको जोडा मिलाउनु होस् :</h5>
        <p>विविधतायुक्त वैभव - भिन्नताले भरिएको सम्पत्ति</p>
        <p>सञ्जीवनी बुटी - जीवन बचाउने औषधी</p>
        <p>अवलोकन भ्रमण - विभिन्न दृश्यको अवलोकनका लागि गरिने भ्रमण</p>
        <p>दिव्य अनुभूति - अलौकिक अनुभूति</p>
        <p>शुक्ल पक्ष - कृष्णपक्ष पछिको पन्ध्र दिन</p>
        <p>सदावहार वनस्पति - सधै हरियो हुने रुखविरुवा</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरू प्रयोग गरी एउटा अनुच्छेद तयार पार्नुहोस् :</h5>
        <p>= निकुञ्ज वनको भित्रि भागमा रहेको सदाबहार बनस्पतिहरूले भरिएको ठाउँ एकदमै शान्त र रमणीय थियो। त्यहीँ कतै उद्गम भएको सानो झरनाले गुलजार फुलहरूलाई झन् आकर्षक बनाएको थियो। बिहानको जम्काभेट त्यो ठाउँसँग हुने जो-कोहीलाई अनुपम अनुभव दिन्थ्यो। साक्षी नाम गरेकी एक युवती पनि त्यही ठाउँमा आफ्नो जीवनको गन्तव्य खोज्दै थिई। प्राकृतिक सौन्दर्यले भरिएको त्यो वनले उसलाई आत्मसन्तुष्टि र शान्तिको अनुभूति दिलायो। त्यस निकुञ्जमा हरियाली मात्र होइन, जीवन बुझ्ने गहिरो अर्थ पनि पाइन्थ्यो।</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका प्राविधिक तथा पारिभाषिक शब्दको अर्थ खोजेर लेख्नुहोस् :</h5>
        <h5>(क) दृश्यावलोकन, अनुभूति, पिरती, कविता ( मानविकी )</h5>
        <p>दृश्यावलोकन : आँखाबाट कुनै दृश्य नियालेर हेर्ने प्रक्रिया।</p>
        <p>अनुभूति : कुनै वस्तु, घटना वा अनुभवबाट उत्पन्न हुने आन्तरिक भावना वा अनुभाव।</p>
        <p>पिरती : माया, प्रेम वा आत्मीय सम्बन्ध।</p>
        <p>कविता : भावनात्मक, कलात्मक र लयात्मक रूपमा लेखिएको साहित्यिक रचना।</p>
        <h5>(ख) कच्ची, जिप, राजमार्ग, बसपार्क ( यातायात क्षेत्र )</h5>
        <p>कच्ची : पक्की सतह नबनेको अस्थायी वा माटोको बाटो।</p>
        <p>जिप : दुर्गम तथा उकालो-ओरालो भूभागमा सवारीका लागि प्रयोग हुने बलियो सानो सवारी साधन।</p>
        <p>राजमार्ग : शहर र शहर, देश र देश जोड्ने लामो तथा चौडा मुख्य सडक।</p>
        <p>बसपार्क : बसहरू रोक्ने, चढ्ने, झर्ने र राख्ने स्थान।</p>
        <h5>(ग) उपत्यका, चट्टान, पर्वत, क्षेत्रफल, हिमाल ( भूगोल )</h5>
        <p>उपत्यका : चारैतिर पहाडले घेरिएको समथर भूमि, जस्तै काठमाडौं उपत्यका।</p>
        <p>चट्टान : पृथ्वीको सतहमा पाइने ठोस तथा कडा ढुंगाजस्तो संरचना।</p>
        <p>पर्वत : धेरै अग्लो र विशाल पहाड।</p>
        <p>क्षेत्रफल : कुनै भू–भागले ओगटेको जमिनको मापन।</p>
        <p>हिमाल : हिउँले ढाकिएको धेरै अग्लो पहाड, जस्तै सगरमाथा।</p>
        <h5>(घ) खस राज्य, बस्ती, शासक, कार्यालय ( प्रशासन )</h5>
        <p>खस राज्य : प्राचीन कालमा पश्चिम नेपालमा खस जातिहरूले स्थापना गरेको राज्य।</p>
        <p>बस्ती : मानिसहरू मिलेर बसोबास गर्ने स्थान, गाउँ वा टोल।</p>
        <p>शासक : शासन गर्ने व्यक्ति वा निकाय, जसको हातमा अधिकार हुन्छ।</p>
        <p>कार्यालय : सरकारी वा अन्य काम सञ्चालन हुने औपचारिक स्थान।</p>
        <h5>(ङ) होटल, खानपान, रिसोर्ट, भ्रमण ( पर्यटन )</h5>
        <p>होटल : यात्रु वा पाहुनालाई खाना, बस्ने ठाउँ आदि सेवा दिने भवन।</p>
        <p>खानपान : खानेकुरा तथा पेय पदार्थहरूको सेवा।</p>
        <p>रिसोर्ट : आराम, अवकाश वा भ्रमणका लागि विशेष सुविधा भएको पर्यटकीय स्थान।</p>
        <p>भ्रमण : घुमफिर गर्ने वा नयाँ स्थान अवलोकन गर्ने क्रियाकलाप।</p>
        <h5>(च) निकुञ्ज, संरक्षण, सदावहार, वनस्पति ( वनविज्ञान )</h5>
        <p>निकुञ्ज : वन्यजन्तु र वनस्पति संरक्षण गर्ने विशेष क्षेत्र, संरक्षित वन।</p>
        <p>संरक्षण : प्राकृतिक स्रोत, जीवजन्तु वा वातावरणलाई नास हुनबाट जोगाउने प्रक्रिया।</p>
        <p>सदावहार : वर्षभरि हरियो रहने र पात नझार्ने वनस्पति।</p>
        <p>वनस्पति : बोटबिरुवा, झारपात, घाँस आदिको समुच्चय। </p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दहरु कुन कुन विषयक्षेत्रसँग सम्बन्धित छन्, पहिचान गरेर लेख्नुहोस् :</h5>
        <p>(क) मानवीय क्षेत्र</p>
        <p>(ख) कृषि तथा वन क्षेत्र</p>
        <p>(ग) इतिहास क्षेत्र</p>
        <p>(घ) प्रशासन क्षेत्र</p>
        <p>(ङ) कानून क्षेत्र</p>
        <p>(च) चिकित्सा क्षेत्र</p>
        <p>(छ) विज्ञान र प्रविधि क्षेत्र</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएका विषय क्षेत्रका आधारमा समूह बनाई हरेक क्षेत्रका दस दसओटा खोज्नुहोस् र कक्षामा प्रस्तुत गर्नुहोस :</h5>
        <strong>(क) शिक्षा</strong>
        <p>कक्षा, विद्यालय, पाठशाला, शिक्षक, अध्ययन</p>
        <strong>(ख) कृषि तथा वन क्षेत्र</strong>
        <p>जोताइ, बाली, बिउ, बनपाखा, बनस्पति, जैविक कृषि</p>
        <strong>(ग) मानविकी र समाजिकशास्त्र</strong>
        <p>संस्कार, संस्कृति, समाज, परम्परा, सामाजिक न्याय, जाति </p>
        <strong>(घ) व्यापार, वाणिज्य</strong>
        <p>बजार, व्यापार, लगानी, नाफा, घाटा</p>
        <strong>(ङ) कानुनी तथा राजनीतिकशास्त्र</strong>
        <p>संविधान, कानुन, न्याय, शासन, अधिकार, कर्तव्य</p>
        <strong>(च) चिकित्सा</strong>
        <p>औषधि, उपचार, रोग, स्वास्थ्य, डाक्टर, नर्स, अस्पताल</p>
        <strong>(छ) विज्ञान तथा प्रविधि</strong>
        <p>प्रयोगशाला, अनुसन्धान, आविष्कार, मेसिन, रोबोट </p>
        <strong>(ज) सञ्चार क्षेत्र</strong>
        <p>सूचना, समाचार, रेडियो, टेलिभिजन, पत्रिका, रिपोर्टिङ </p>
        <strong>(झ) जनप्रशासन</strong>
        <p>योजना, सचिव, बजेट, सेवा प्रवाह, कर्मचारी</p>
        <strong>(ञ) इन्जिनियरिङ</strong>
        <p>नक्सा, ढाँचा, प्रविधि, निर्माण, सडक, पुल, भवन </p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. पाठका आधारमा उत्तर भन्नुहोस् :</h5>
        <h5>(क) दैनिकीलाई कस्तो ढाँचामा प्रस्तुत गरिएको छ ?</h5>
        <p>= दैनिकीलाई यात्रावर्णनको ढाँचामा प्रस्तुत गरिएको छ।</p>
        <h5>(ख) दैनिकीमा प्रयोग भएको सबैभन्दा ठूलो र सानो अनुच्छेद संरचना कुन कुन हुन् ?</h5>
        <p>= दैनिकीमा प्रयोग भएको सबैभन्दा ठूलो अनुच्छेद १९औं हो भने सानो अनुच्छेद २५औं अनुच्छेद हो।</p>
        <h5>(ग) दैनिकीको सुरुदेखि अन्त्यसम्मका संरचनालाई जोड्ने आधार के हो ?</h5>
        <p>= दैनिकीको सुरुदेखि अन्त्यसम्म संरचनालाई जोड्ने आधार घटनाहरू हुन्।</p>
        <h5>(घ) दैनिकीको दोस्रो दिनका घटनाहरुको सूची बनाउनुहोस् ।</h5>
        <p>= दैनिकीको दोस्रो दिनका घटनाहरूको सूची :</p>
        <p>1. जिपमा लामो समय यात्रा गरेकाले धेरै थकाइ अनुभव हुनु र सूर्खेतको एक होटलमा बस्नु।</p>
        <p>2. भोलिपल्ट बिहान ५ बजे सूर्खेतबाट राराको यात्राका लागि निस्कनु।</p>
        <p>3. कर्णाली नदीको किनार–किनार हुँदै यात्रा अगाडि बढाउनु।</p>
        <p>4. कालीकोट सदरमुकाम हुँदै नाग्मगाढाबाट सिन्जा उपत्यका पुग्नु।</p>
        <p>5. सिन्जाको हरियाली वातावरणको अवलोकन गर्दै हिँड्नु।</p>
        <p>6. सिन्जामा खाना खाएर फेरि यात्रा सुरु गर्नु।</p>
        <p>7. रारा राष्ट्रिय निकुञ्जको चेकपोस्ट पार गरेर रारा नजिकैको रिसोर्टमा पुग्नु र त्यहाँ झोला बिसाउनु।</p>
        <p>8. साँझ आगो ताप्दै आराम गर्नु र राति राराको दृश्यावलोकन गर्नु।</p>
        <p>9. रिसोर्टमा चिया पिउँदै नाचगानको आनन्द लिनु।</p>
        <p>10. तराईको गर्मीबाट गएकालाई राराको क्षेत्रमा चिसो महसुस हुनु।</p>
      </div>
      <hr/>
      <div>
        <h5>२. "बिहानै मिर्मिरे ……जागिरहँदो रहेछ " दैनिकी अंशका आधारमा दिइएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) रारा तालका बेताल लहरहरु कस्ता थिए ?</h5>
        <p>= रारा तालका बेताल लहरहरु बैसले छचल्किएका र पिरती गाँस्न हतारिएका जस्ता थिए ।</p>
        <h5>(ख) राराले शासकलाई पनि कसरी कवि बनाउन सक्दो रहेछ ?</h5>
        <p>= राराले शासकलाई आफ्नो प्राकृतिक सौन्दर्यको जादुले कवि बनाउन सक्दो रहेछ ।</p>
        <h5>(ग) राराको सुन्दरतालाई किन जादु भनिएको हो ?</h5>
        <p>= रारालाई हेर्न आउने पर्यटकहरुको दिन चोर्न क्षेमता भएकाले राराको सुन्दरतालाई जादु भनिएको हो ।</p>
        <h5>(घ) यस अनुच्छेदमा राराको प्राकृतिक सौन्दर्यको वर्णन कसरी गरिएको छ ?</h5>
        <p>= यस अनुच्छेदमा बैसले छचल्किए जस्ता बेताल लहरहरु किनारसम्म आएर पर्यटकहरुसँग पिरती गाँस्न हतारिए जस्ता देखिने, पर्यटकको दिल चोर्न सदा जादु देखाउने क्षमता रारा तालमा छ भनी सौन्दर्यको वर्णन गरिएको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएको दैनिकी अंशका आधारमा सोधिएका प्रश्नहरुको उत्तर लेख्नुहोस् :</h5>
        <h5>(क) सिँजा उपत्यकाको चिनारी दिनुहोस् ।</h5>
        <p>= सिँजा उपत्यकाको वरिपरि रमणीय वस्तु र खेतीयोग्य जमिनलाई हिम नदीले सिँचाइ पुर्‍याउने सिजा उपत्यका एउटा ऐतिहासिक स्थल रहेछ । यसका बाइसे खस राज्यको राजधानी, नेपाली भाषाको उद्गम स्थलको रुपमा सिजाको ऐतिहासिकता झल्कन्छ । तसर्थ पवित्रता, खाद्यान्नको भण्डार भएको ऐतिहासिक भूमि नै सिँजा उपत्यकाको चिनारी हो ।</p>
        <h5>(ख) लेखकले सिँजादेखि रारासम्मको यात्रा कसरी पूरा गरे ?</h5>
        <p>= लेखकले सिँजादेखि रारासम्मको यात्रा मालिका बोतादेखि चट्टानलाई चिर्दै चौथा भन्ने ठाउँमा पुगी उकालिँदै घुच्चीको लेकमा रारा राष्ट्रिय निकुञ्जको चेक पोस्टमा पुगेपछि पिनागाउँ हुँदै रारा ताल नजिकैको सल्लेरीको जङ्गलमा पुगेपछि गाडी रोकेर झोला बोकी करिब एक घण्टा हिँडेर पूरा गरे ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. उत्तर दिनुहोस् :</h5>
        <h5>(क) पाठका आधारमा राराको परिचय दिनुहोस् ।</h5>
        <p>= समुद्री सतहदेखि २८७२ मिटरको उचाइमा अवस्थित राराको लम्बाइ अधिकतम पाँच किलोमिटर र चौडाइचाँहि अधिकतम ३.२ किलोमिटर छ । १०.८ वर्ग किलोमिटर क्षेत्रफल रहेको यो तालले विशालता, उच्चता र भब्यता प्रदर्शन गरेको छ । चारैतिर सदाबहार वनस्पतिले भरिएका पहाडले घेरिएकाले राराको पानी नै हरियो देखिन्छ । राराका बेताल लहरहरु बैँसले छचल्किएका अनि पिरती गाँस्न हतारिएका देखिन्छन् । यहाँका प्रत्येक जडीबुटीका जरालाई राराले नै अमृत प्रदान गरेको छ । स्वर्गको एक टुक्रा जस्तै देखिने यो ताल प्राकृतिक सुन्दरताले भरिएको एक अनुपम उपहार हो ।</p>
        <h5>(ख) दैनिकी लेखकले पहिलो दिनको यात्रा कसरी पूरा गरे ?</h5>
        <p>= बिहान साढे तीन बजे ब्युझिएका लेखक नित्यकर्म गरी चार बजे तिर पाँच जना साथीहरुसहित गुल्मी तल्ला फाँटबाट जिप चढी राराको यात्रा सुरु गरी रुद्रावती नदी तरी किनारै किनार हुँदै निस्किएका थिए । उनीहरुको टोलि मकुवा, चोरकाटे, उल्लीखोला, खैरेनीका फँटहरु छिचोल्दै रुद्रवेणी हुँदै रिडी पुगे । त्यसपछि अर्गली, जोर्ते, लगुवा, हार्थोक हुँदै करिब साढे सात बजे पाल्पा तानसेन पुगेर पकौडा, चुकाउनी र चिया खाएर नौ बजे बुटवल पुगेका लेखक साँझ चार बजे कोहलपुर पुगेका थिए । त्यसपछि हिडेको जिप ७५ किलोमिटर पार गरेर ९ बजेतिर सुर्खेत पुगी त्यहाँको बसपार्ककै एक होटलमा बास बसे । यसरी दैनिकी लेखकले पहिलो दिनको यात्रा पूरा गरे ।</p>
        <h5>(ग) रारा पुगेर लेखक किन खुसी भए ?</h5>
        <p>= गुल्मीबाट रारासम्मको यात्रा गर्ने क्रममा कर्णाली नदी किनार, अर्धकच्ची बाटो, फाँट, नागवेली घुम्ती बाटो, पूर्व पश्चिम राजमार्ग, कर्णाली राजमार्ग, सुन्दर उपत्यका, सिँजा उपत्यका, रमणीय बस्ती, खेत आदि दृश्यहरु देख्दा आनन्दको अनुभूति गरेका छन् । चारैतिर सदाबहार वनस्पतिले भरिएका पहाडले डिल लगाएजस्ता डाँडाहरुले घेरिएको रारा ताल देखेर उनि खुसी भए । साथै तालको गाढा हरियो पानीमा बैंसले छचल्किएका बेताल लहरहरुको मादकताले दिल चोरेकाले रारा पुगेर लेखक खुसी भए ।</p>
        <h5>(घ) यस दैनिकीमा लेखकको कस्तो प्रकारको अनुभूति प्रस्तुत भएको छ ?</h5>
        <p>= यस दैनिकीमा लेखकले बाटामा देखिएका र भेटिएका स्थानलाई आफ्नै अनुभवका आधारमा प्रस्तुत गरेका छन् । उनले राराको वर्णन पनि निजी अनुभूतिका आधारमा गरेका छन् । आफ्नो सपनाको गन्तब्य रारा तालमा पुग्दा रारा तालका बेताल लहरहरुलाई बैँसले छचल्किएका अथवा पिरती गाँस्न हतारिएका हुन् ठम्याउन गाहो परेको रोमाञ्चित अनुभूत गरेका छन् । यात्रा गर्ने क्रममा कर्णाली नदी किनार, अर्धकच्ची बाटो, फाँट, नागवेली घुम्ती बाटो, पूर्व पश्चिम राजमार्ग, कर्णाली राजमार्ग, सुन्दर उपत्यका, सिँजा उपत्यका, रमणीय बस्ती, खेत आदि दृश्यहरु देख्दा आनन्दको अनुभूति गरेका छन् । हाँको रमणीय प्राकृतिक वातावरण देख्दा गौरलूले छाती फुलाउँदै नेपाली हुनुको गौरव अनुभूति गरेका छन् । राराका छालहरु आफूसँग जिस्कँन आएको वा पिरती गाँस्न आएको श्रृङ्गारिक रसको अनुभूति गर्दछन् । घाम जुन बादल, पहाड, हिमालहरु राराका लहरमा हाम्फाल्दै अपूर्व आनन्द होला भनी प्रकृतिलाई मानवीकरण गरी आत्मिक आनन्दको रसानुभूति गरेका छन् । तसर्थ यस दैनिकीमा लेखकको निजी व्यक्तिगत अनुभूतिको प्रस्तुत भएको पाइन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. यस दैनिकीमा प्रकृतिलाई कसरी मानवीकरण गरिएको छ, वर्णन गर्नुहोस् ।</h5>
        <p>= कुनै वस्तुलाई मानिसका जस्तै क्रियाकलापमा समावेश गराउनु वा मानवका रुपमा कल्पित तथा प्रस्तावित गर्ने काम नै मानवीकरण हो । यस दैनिकीमा प्रकृतिलाई मान्छेको जस्तै क्रियाकलापहरु गर्न लगाइएको छ । नदीनाला, ताल, पहाड, हिमाल, उपत्यका, वनजङ्गल, आगोपानी, बाटाघाटा, जुन, घाम आदिलाई मान्छेका जस्तै गतिविधि वा क्रियाकलापका रुपमा प्रस्तुत गरिएको छ । रद्रावती नदीको काख, रारा राष्ट्रिय निकुञ्जसँग जम्काभेट हुनु, सिँजा दङ्ग पर्नु, आगाको तातो र राराको चिसो बिचको द्वन्द्व चल्नु, राराको आँगनीमा पुग्नु, राराका छालहरु बैसले छचल्किएर पिरती गाँस्न आउनु, पर्यटकको राराले दिल चोर्नु, राराले मन पखाल्नु, रारा ताल पर्यटकसँग जिस्कनु, रारामा दिउँसो र राती, घाम र जुन पालो गरेर पौडी खेल्नु, रारालाई वरिपरीका पहाड र जङ्गलले पहरा दिनु आदि यस दैनिकीमा प्रकृतिलाई मानवीकरण गरिएका उदाहरण हुन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. दैनिकी पढी मुख्य मुख्य घटना टिपोट गर्नुहोस् ।</h5>
        <p>= दैनिकीका मुख्य–मुख्य घटनाहरू निम्न अनुसार छन् :</p>
        <p>1. २०७७ जेठ २३ गते बिहान साढे तीन बजे उठ्नु।</p>
        <p>2. लेखकसहित छ जनाको टोली गुल्मीबाट रारासम्मको यात्राका लागि जिपमा हिँड्नु।</p>
        <p>3. रिडी हुँदै पाल्पाको जोरधारा पुगेर पकौडा, चुकाउनी र चिया खानु।</p>
        <p>4. बिहान ९ बजे बुटवलबाट हिँडेको टिम साँझ ४ बजे कोहलपुर र राति ९ बजे सुर्खेत बसपार्क पुगेर होटेलमा बस्नु।</p>
        <p>5. २०७७ जेठ २४ गते बिहान ५ बजे सुर्खेतबाट निस्कनु र कर्णाली नदीको किनार हुँदै जितेगाढ पुग्नु।</p>
        <p>6. कालिकोटको सदरमुकाम हुँदै सिँजा उपत्यकाको रमणीय दृश्य अवलोकन गर्दै, त्यहाँ खाना खाएर रारा राष्ट्रिय निकुञ्जको चेकपोस्ट पार गर्नु।</p>
        <p>7. सल्लेरी जङ्गलमा जिप छाडेर बाँस बस्ने रिसोर्टसम्म पुग्नु।</p>
        <p>8. २०७७ जेठ २५ गते बिहान ५ बजे उठेर राराको प्राकृतिक सौन्दर्य अवलोकन गर्नु।</p>
        <p>9. राराको पाँच किलोमिटर क्षेत्र हिँडेर पुरा गर्नु र रमणीय दृश्यको अनुभव लिनु।</p>
        <p>१०.8 वर्ग किलोमिटर क्षेत्रफल ओगटेको रारा ताल हेरेपछि, लेखकसहितको टोली आफ्नो वासस्थान फर्किनु।</p>
      </div>
      <hr/>
      <div>
        <h5>७. तपाईं सहभागी भएको कुनै कार्यक्रमको वर्णन गर्दै एक दिनको दैनिकी तयार पार्नुहोस् ।</h5>
        <strong>२०७८ असार १८ गते, शुक्रवार</strong>
        <p>स्थान: जिल्ला अस्पताल, गुल्मी</p>
        <p>कार्यक्रम: रक्तदान कार्यक्रम</p>
        <p>दैनिकी:</p>
        <p>आजको बिहान मौसम अलिकति बादल लागेको थियो, असार महिना भएकाले हल्का झरी परिरहेको थियो। म बिहान ६:३० बजे उठें। बिहानको खाजा खाएर, झोला समातेर ७:३० बजे कार्यक्रम स्थलतर्फ लागें।</p>
        <p>जिल्ला अस्पताल परिसरमा पुग्दा कार्यक्रमको तयारी भइसकेको थियो। रक्तदान अभियानको ब्यानर झुण्ड्याइएको थियो र स्वयंसेवकहरू उत्साहित देखिन्थे। म पनि दर्ता कक्षमा गएर आफ्नो नाम, उमेर, र रक्त समूह लेखाएँ। स्वास्थ्य परीक्षण पछि मलाई रक्तदान गर्न मिल्छ भन्ने जानकारी दिइयो।</p>
        <p>८:४५ बजे मेरो रक्तदानको पालो आयो। पहिलो पटकको अनुभव थिएन, तर हरेकपटक सानो डर हुन्छ नै। स्वास्थ्यकर्मीहरूको सान्त्वनासहित म आरामले रक्तदान गरें। १० मिनेटमै सकियो। त्यसपछि मलाई आराम गर्न भनियो, र जुस तथा बिस्कुट दिइयो।</p>
        <p>रक्तदानपछि मैले कार्यक्रम अवलोकन गरें। एक जना डाक्टरले "रक्तदान–जीवनदान" विषयमा छोटो भाषण गर्नुभयो, जुन धेरै प्रेरणादायक लाग्यो। केही साथीहरूलाई पनि रक्तदान गर्न उक्साएँ।</p>
        <p>१२:३० बजे कार्यक्रम सम्पन्न भयो। हामी सहभागीहरूलाई प्रशंसा पत्र प्रदान गरियो। कार्यक्रमबाट फर्किंदा मन हल्का, सन्तुष्ट र गर्वित महसुस भयो।</p>
        <p>आज असार १८, धान रोपाइँको दिन मात्र होइन, मैले जिन्दगी रोप्ने काम गरेजस्तो लाग्यो। यस्तो सानो योगदानले कसैको जीवन बच्न सक्छ भन्ने सोचले मन थप उत्साहित बन्यो।</p>
      </div>
      <hr/>
      <div>
        <h5>१०. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको उत्तर लेख्नुहोस् ।</h5>
        <h5>(क) मिथिला लोककलामा महिलाको कस्तो भूमिका छ ?</h5>
        <p>= मिथिला लोककलाको सुरुवात, सम्बर्द्धन संरक्षणमा महिलाको भूमिका महत्वपूर्ण रहेको छ ।</p>
        <h5>(ख) अल्पना किन निर्माण गरिन्छ ?</h5>
        <p>= घरमा आउँदा र निस्कँदा शुभसाइत हुन्छ भनी अल्पना निर्माण गरिन्छ ।</p>
        <h5>(ग) मिथिला लोककलालाई के कसरी वर्गीकरण गरिएको छ ?</h5>
        <p>= मिथिला लोककलालाई भित्तेचित्र, भूमिचित्र, पटचित्र, काष्ठचित्र, वास्तुचित्र, भाण्डचित्र र व्यक्तिचित्र गरेर वर्गीकरण गरिएको छ ।</p>
        <h5>(घ) माङ्गलिक र द्योतक शब्दको अर्थ लेख्नुहोस् ।</h5>
        <p>= माङ्गलिक : शुभ</p>
        <p>द्योतक : उज्यालो पार्ने, प्रकाश पार्ने ।</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. दिइएको अनुच्छेदबाट द्वित्व शब्द छानेर लेख्नुहोस् :</h5>
        <p>ससाना, गाडीसाडी, आलीआली, सानासाना, ठुलाठुला, आआफ्ना, धनसन, खानासाना</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुबाट द्विरुक्त शब्द बनाउनुहोस् :</h5>
        <p>घर : घरघर</p>
        <p>बजार : बजारसजार</p>
        <p>साथी : साथीसाथी</p>
        <p>मान्छे : मान्छेमान्छे</p>
        <p>पानी :पानीपानी</p>
        <p>फूल : फूलसुल</p>
        <p>हिमाल : हिमालसिमाल</p>
        <p>चित्र : चित्रमित्र</p>
        <p>किताब : किताबसिताब</p>
        <p>गाडी : गाडीसाडी</p>
        <p>सामान : सरसामान</p>
        <p>गहना : गरगहना</p>
        <p>झगडा : झै-झगडा</p>
        <p>सापटी : सरसापटी</p>
        <p>झल्को : झ-झल्को</p>
        <p>ठूलो : ठुलोठुलो</p>
        <p>थर्को : थथर्को</p>
        <p>सर : सरासर</p>
        <p>बर : बरबर</p>
        <p>एक : एकएक</p>
        <p>चार : चारचार</p>
        <p>पैँचो : ऐचोपैँचो</p>
        <p>बानी : आनीबानी</p>
        <p>पैसा : पैसापैसा</p>
        <p>चिया : चियासिया</p>
        <p>तरकारी : तरकारीसरकारी</p>
        <p>फोन : फोनसोन</p>
        <p>बोली : बोलीसोली</p>
        <p>टेबल : टेबलसेबल</p>
        <p>कलेज : कलेजसलेज</p>
        <p>लुगा : लुगासुगा</p>
        <p>बजार : बजारबजार</p>
        
      </div>
      <hr/>
      <div>
        <h5>३. दिइएक द्विरुक्त शब्दहरुलाई उस्तै उस्तै समूहमा सूचीबद्ध गरि निर्माण प्रक्रिया समेत देखाउनुहोस् :</h5>
        <p>हात हात : हात + हात</p>
        <p>गर्गहना : गहना + गहना</p>
        <p>खोला खोला : खोला + खोला</p>
        <p>सर्सल्लाह : सल्लाह + सल्लाह</p>
        <p>छोरी छोरी : छोरी + छोरी</p>
        <p>गोदगाद : गोद + गोद</p>
        <p>गाडी गाडी : गाडी + गाडी</p>
        <p>आनीबानी : बानी + बानी</p>
        <p>ससानो : सानो + सानो</p>
        <p>झझल्को : झल्को + झल्को</p>
        <p>दुधसुध : दुध + दुध</p>
        <p>चोरचार : चोर + चोर</p>
      </div>
      <hr/>
      <div>
        <h5>४. 'रारा भ्रमण ' बाट द्वित्व प्रक्रियाबाट बनेका दशओटा शब्दहरु टिप्नुहोस् र द्वित्व विच्छेद गर्नुहोस् :</h5>
        <p>किनारै किनार : किनार + किनार</p>
        <p>हर्ल्याङहुर्लुङ : हर्ल्याङ + हर्ल्याङ</p>
        <p>आआफ्नो : आफ्नो आफ्नो</p>
        <p>आलोपालो : पालो + पालो</p>
        <p>कुट्दाकुट्दै : कुट्दै + कुट्दै</p>
        <p>छचल्किनु : छल्किनु + छल्किनु</p>
        <p>सँगसँगै : सँगै + सँगै</p>
        <p>तलतल : तल + तल</p>
        <p>माथि मथि : माथि + माथि</p>
        <p>फाट्टफुट्ट : फाट्ट + फाट्ट</p>
      </div>
      <hr/>
      <div>
        <h5>१. दिइएका अनुच्छेदबाट सन्धियुक्त शब्द पहिचान गरी सन्धि विच्छेद गर्नुहोस् :</h5>
        <p>(क) नरेश : नर + ईश</p>
        <p>अत्याचार : अति + आचार</p>
        <p>सूर्योदय : सूर्य + उदय</p>
        <p>रुवाइ : रु + आइ</p>
        <p>कमाइ : काम + आइ</p>
        <p>(ख) निष्काम : निष् + काम</p>
        <p>दुराशय : दुर् + आशय</p>
        <p>मानवोचित : मानव + उचित</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुको सन्धि विच्छेद गर्नुहोस् :</h5>
        <p>पुस्तकालय : पुस्तक + आलय</p>
        <p>चन्द्रोदय : चन्द्र + उदय</p>
        <p>सूक्ति : सूक्त + इ</p>
        <p>नारीश्वर : नारी + ईश्वर</p>
        <p>आज्ञानुसार : आज्ञा + अनुसार</p>
        <p>देवर्षि : देव + ऋषि</p>
        <p>नरेन्द्र : नर + इन्द्र</p>
        <p>धीरेन्द्र : धीर + इन्द्र</p>
        <p>उल्लेख : उत् + लेख</p>
        <p>संवाद : सम् + वाद</p>
        <p>उद्बोध : उत् + बोध</p>
        <p>सङ्कीर्ण : सम + कीर्ण</p>
        <p>सन्देश : सम् + देश</p>
        <p>दिगम्बर : दिग + अम्बर</p>
        <p>जगदीश : जगत + ईश</p>
        <p>उल्लास : उत् + लास</p>
        <p>सद्भावना : सत् + भावना</p>
        <p>सन्न्यास : सत् + न्यास</p>
        <p>यशोधरा : यस + धरा</p>
        <p>पुनर्कथन : पुनर + कथन</p>
        <p>मनोरञ्जन : मन + अञ्जन</p>
        <p>हतियार : हात + इयार</p>
        <p>ढकनी : ढक + अनी</p>
        <p>पन्यालो : पानी + आलो</p>
        <p>प्रेमर्षि : प्रेम + ऋषि</p>
        
      </div>
      <hr/>
      <div>
        <h5>३. अन्तिम दिनको दैनिकीको चौथो अनुच्छेद पढी सन्धियुक्त चारवटा शब्द खोजी सन्धि विच्छेद गर्नुहोस् :</h5>
        <p>मादक : मद + अक</p>
        <p>देखेर : देख् + एर</p>
        <p>ठडिएका : ठाडो + एका</p>
        <p>देखिने : देख् + इने</p>
      </div>
    </div>
  )
}

export default Raravraman
